import { useUser } from "@/auth/useUser";
import { useClientAccessToken } from "@/contexts/clientAccessTokenContext";
import { useStripeAccountIdQuery } from "@/graphql/queries/stripeAccountId.graphql.types";
import useClientFormsByToken from "@/hooks/client/useClientFormsByToken";

export default function useStripeAccountId() {
  const { clientAccessToken: token } = useClientAccessToken();

  /**
   * For regular pages with regular authentication we get user data from useUser(),
   * but for pages that get data access via client token we use useClientFormsByToken().
   */
  const { medspa: medspaFromClientForms } = useClientFormsByToken(
    token as string
  );
  const { medspa: medspaIdFromUseUser } = useUser();

  const medspa = medspaIdFromUseUser || medspaFromClientForms?.id;

  return useStripeAccountIdQuery({
    variables: {
      medspaId: medspa,
    },
    skip: !medspa,
  });
}
